import { ScheduledSectionStatus } from '../../views/course_scheduler/types/scheduled_section_status_enum';
import { LoadSectionRegistrationAttributesCommand } from './load_section_registration_attributes_command';
import { ISectionRegistrationAttributesDatasource } from '../datasources/section_registration_attributes_datasource';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { RegistrationAttributesFacade } from '../facades/registration_attributes_facade';

export type LoadAllRegistrationAttributesForSectionsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'loadAllRegistrationAttributesForSectionsCommand',
    (
      defineCommandORM: IDefineCommand,
      loadSectionRegistrationAttributesCommand: LoadSectionRegistrationAttributesCommand,
      ngSectionsDatasource: ISectionsDatasource,
      $q: ng.IQService,
      log: any,
      ngRegistrationAttributesFacade: RegistrationAttributesFacade,
      ngSectionRegistrationAttributesDatasource: ISectionRegistrationAttributesDatasource
    ) => {
      return defineCommandORM('loadAllRegistrationAttributesForSectionsCommand', (deferred: ng.IDeferred<IQuery[]>) => {
        const loadRegistrationAttributesFeatureEnabled = ngRegistrationAttributesFacade.isFeatureEnabled();
        if (!loadRegistrationAttributesFeatureEnabled) {
          deferred.resolve();
          return;
        }
        const allSectionIds = ngSectionsDatasource
          .values()
          .filter((section) => !_4.includes([ScheduledSectionStatus.PENDING], section.status))
          .filter((section) =>
            _4.includes(
              [
                ScheduledSectionStatus.SECTION_PICKED,
                ScheduledSectionStatus.WAITLISTED,
                ScheduledSectionStatus.WAITLISTDROPFAILED,
                ScheduledSectionStatus.WAITLISTEDCANADD,
                ScheduledSectionStatus.WAITLISTFAILED
              ],
              section.status
            )
          )
          .map((section) => section.id);
        const sectionIdsForRegAttrLoading = allSectionIds.filter((id) =>
          _4.isEmpty(ngSectionRegistrationAttributesDatasource.get(id))
        );
        const loadAllRegistrationAttributesForSections = sectionIdsForRegAttrLoading.map((sectionId) =>
          loadSectionRegistrationAttributesCommand(sectionId)
        );
        $q.all(loadAllRegistrationAttributesForSections)
          .then(() => deferred.resolve())
          .catch((e) => {
            log.issue(`Failed to load the registration attributes for sections`);
            deferred.reject(e);
          });
        return;
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/load_all_registration_attributes_for_sections_command.ts